var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"down-text-class"},[_vm._v(_vm._s(_vm.hours + 'H')+" "+_vm._s(_vm.minutes + 'M')+" "+_vm._s(_vm.seconds + 'S'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }